module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/af627820e3114b93ef21d4a7de42e80b.gif";